import {BrowserRouter as Router,Switch, Route,Redirect,useHistory} from "react-router-dom";
import config from './configurations/config'
import './App.css';
import { useEffect, useState } from 'react';
import routes from "./route";
import Layout from './components/Layout'
import { authenticatedUser, token } from './services/AuthenticationService';
import { ACCOUNTS_PATH } from "./components/Constants";

function App(props) {
  const [refresh,setRefresh]=useState(true);
  const history = useHistory();
  useEffect(()=>{
    setIdToken()
 },[])
 const setIdToken=()=>{
  authenticatedUser().then(user => {
        if (Object.keys(user).length === 0) {  
          console.log("Came redirect login");
          window.location.href = `${config.auth.URL}login`;   
        } else {
          token().then(token => {
            console.log("Token in portal ....", token);
            if (Object.keys(token).length === 0) {
              window.location.href = `${config.auth.URL}login`;
            } else {
              sessionStorage.setItem("idToken",token.token); 
              setRefresh(false)   
            }
          }).catch(exp => {
            window.location.href =`${config.auth.URL}login`;   
          });
        }         
       }).catch(e => {
         console.log(e);
         window.location.href = `${config.auth.URL}login`;
       });
}

if(refresh){
return <div><p>authentication is being performed</p></div>
}else
  return (

<Router >
  <Switch>
    <Route
      // path={"/"}
      render={props => {
        return (
          <Layout {...props}>
            <Switch>
              {routes.map(route =>(
                <Route
                  key={route.path}
                  path={route.path}
                  history={history}
                  component={route.component}
                />
              ))}
              <Redirect from="/" to= {ACCOUNTS_PATH} />
            </Switch>
          </Layout>
        );
      }}
    />
  </Switch>
</Router>
  );
}

export default App;